// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"CustomInput_Wrapper__3F48h","Title":"CustomInput_Title__2oKmh","Error":"CustomInput_Error__tPr3V","FormItem":"CustomInput_FormItem__D57R1"};